import { t } from '@trimble/i18n';
import { Component, JSXElement } from 'solid-js';

const ActiveLabel: Component = (): JSXElement => (
  <span
    class="text-sm pr-2"
    data-testid="active-layer-tree-label"
    textContent={t('mobileMapping.cadEditing.projectData.activeLabel')}
  />
);

export default ActiveLabel;
